import { trpc } from '@/shared/api';
import { designThumbnailRefetchInterval } from '../model/thumbnail-polling';

interface QuoteRequestFormQueryOptions {
  readonly enabled?: boolean;
}

/** 견적 요청 정보(quotes.getRequestForm) — 상품·색상·최소 수량·구간 단가·인쇄 방식·기본 담당자명·원본 디자인 썸네일. */
export const useQuoteRequestFormQuery = (
  designId: string,
  options: QuoteRequestFormQueryOptions = {},
) =>
  trpc.quotes.getRequestForm.useQuery(
    { designId },
    {
      enabled: options.enabled ?? true,
      // 준비 중(PRECONDITION_FAILED)·요청 불가 디자인은 재시도해도 같다.
      retry: false,
      // 에디터는 저장 직후(새 그림을 그리기 전) 넘어온다 — 원본 디자인 그림이 생길 때까지 잠깐 다시 조회한다
      // (창이 뒤에 있거나 다시 조회가 실패하면 멈춤, 응답 수 상한 — 조회마다 상품 잠금을 잡는 폼 전체를 다시 읽는다).
      // 폼 입력은 처음 값만 받으므로 다시 조회해도 고객이 적은 값은 그대로다.
      refetchInterval: (query) => {
        const form = query.state.data;
        return form ? designThumbnailRefetchInterval(form.thumbnail !== null, query.state) : false;
      },
    },
  );
